import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { saveBomItemQuantity } from '../store/asyncActions/saveBomItemQuantity'
import { ProjectTextField } from '../store/components/ProjectTextField'
import { ValueLabelConnected } from '../store/components/ValueLabelConnected'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { bomItemQuantitySelector } from '../store/selectors/bomItemQuantitySelector'
import { ProjectEditableStateSelector } from '../store/selectors/ProjectEditableStateSelector'
import { rowIsIndividualPart } from '../store/selectors/rowIsIndividualPart'
import { valueGreaterThanZero } from '../Validations/valueGreaterThanZero'

type Props = {
  bomItemId: string
  className?: string
  translationKey?: string
}

export function BomItemQuantity(props: Props) {
  const { t } = useTranslation()

  const isIndividualPart = useAppSelector(rowIsIndividualPart(props.bomItemId))
  const projectIsEditable = useAppSelector(ProjectEditableStateSelector)
  const canEditRow = useAppSelector(
    projectSelectors.canEditRowSelector(props.bomItemId)
  )

  if (isIndividualPart || !projectIsEditable || !canEditRow) {
    return (
      <ValueLabelConnected
        propertySelector={bomItemQuantitySelector(props.bomItemId)}
        valueLabelProps={{
          label: t(props.translationKey || 'project:batch-size'),
          valueProps: {
            className: props.className,
          },
          isLeftAligned: true,
        }}
      />
    )
  }

  return (
    <ProjectTextField
      valueSelector={bomItemQuantitySelector(props.bomItemId)}
      actionTypePrefix={saveBomItemQuantity.typePrefix.concat(
        '/',
        props.bomItemId
      )}
      saveAction={(value) =>
        saveBomItemQuantity({
          bomItemId: props.bomItemId,
          quantity: value,
        })
      }
      textFieldProps={{
        label: t(props.translationKey || 'project:batch-size'),
        required: true,
        type: 'number',
        className: props.className,
      }}
      validation={valueGreaterThanZero}
    />
  )
}
